import apiFetch from "@/lib/fetch";
import { Skeleton } from "@/components/ui/skeleton";
import CampaignClientSection from "@/components/views/campaings/infinite-scroll/CampaignClientSection";
import HeaderDataCount from "@/components/views/common/HeaderDataCount";
import { DEFAULT_CACHE_DURATION } from "@/@core/constants/cache";
import CampaignOffersJsonLd from "@/components/global-schema/CampaignOffersJsonLd";

export default async function CampaignsSection(props: SearchProps) {
  let url = "campaign?index=0";

  if (props.service) url += `&service=${props.service}`;
  if (props.district) url += `&district=${props.district}`;
  if (props.venue) url += `&venue=${props.venue}`;

  const [campaigns, site] = await Promise.all([
    apiFetch({
      route: url,
      revalidate: DEFAULT_CACHE_DURATION,
    }),
    apiFetch({ route: "sites", tags: ["sites"] }),
  ]);

  return (
    <div>
      {/* The campaign structured data is built here, from the very list that
          feeds the cards below, so the two can never drift apart — and it is
          emitted only here, even though the campaigns are rendered again in the
          map view and inside the detail modal. */}
      <CampaignOffersJsonLd
        site={site}
        campaigns={campaigns}
        districtData={props.districtData}
        serviceData={props.serviceData}
      />

      <HeaderDataCount count={campaigns?.summary} />

      <CampaignClientSection {...props} data={campaigns} />
    </div>
  );
}

export function CampaignsLoading() {
  return (
    <div
      id="campaign-card-skeleton"
      className="xl:grid justify-items-center flex flex-wrap justify-center xl:grid-cols-3 gap-5"
    >
      {[...Array(6)].map((_, index) => (
        <Skeleton
          key={index}
          className="custom-animate-pulse w-full lg:w-[389px] h-[251px] rounded-4xl"
        />
      ))}
    </div>
  );
}
